import { type GoogleProtobufTimestamp, type Maybe } from "../../../gql-generated/types";

export const timestampToDate = (datetime: Maybe<GoogleProtobufTimestamp> | undefined): Date | null => {
    if (!datetime) {
        return null;
    }

    const seconds = Number.isInteger(datetime.seconds) ? datetime.seconds : 0;
    const nanos = Number.isInteger(datetime.nanos) ? datetime.nanos : 0;

    return new Date(seconds * 1000 + nanos / 1e6);
};
